import { IStoryblokStory } from '~/src/interfaces/storyblock'

export const filterPath = (story: IStoryblokStory) => {
  if (!story) return [];

  return story.full_slug.split('/')
    .filter(e => e !== process.env.GATSBY_MARKET)
    .filter(e => e !== story.lang)
}
